import { addError, removeError } from '../utils/error-functions';
var FormValidator = /** @class */ (function () {
    function FormValidator() {
    }
    FormValidator.validateForm = function (tabFormArray) {
        tabFormArray.controls.forEach(function (individualFormGroup) {
            var formsWithSameName = tabFormArray.controls.filter(function (anotherFormGroup) {
                var anotherFormId = anotherFormGroup.value.form && anotherFormGroup.value.form.id;
                var formId = individualFormGroup.value.form && individualFormGroup.value.form.id;
                var anotherMaintenanceTypeId = anotherFormGroup.value.maintenanceType && anotherFormGroup.value.maintenanceType.id;
                var maintenanceTypeId = individualFormGroup.value.maintenanceType && individualFormGroup.value.maintenanceType.id;
                var anotherSelectedMaintenanceTypeId = anotherFormGroup.value.maintenanceType && anotherFormGroup.value.maintenanceType.selectedMaintenanceType && anotherFormGroup.value.maintenanceType.selectedMaintenanceType.id;
                var selectedMaintenanceTypeId = individualFormGroup.value.maintenanceType && individualFormGroup.value.maintenanceType.selectedMaintenanceType && individualFormGroup.value.maintenanceType.selectedMaintenanceType.id;
                return anotherFormId === formId &&
                    ((anotherSelectedMaintenanceTypeId || anotherMaintenanceTypeId) === (selectedMaintenanceTypeId || maintenanceTypeId));
            });
            formsWithSameName.forEach(function (control) {
                var isDuplicated = formsWithSameName.length > 1;
                var formControl = control.get('form');
                if (isDuplicated) {
                    addError(formControl, 'formDuplicated');
                }
                else {
                    removeError(formControl, 'formDuplicated');
                }
            });
        });
        return null;
    };
    return FormValidator;
}());
export { FormValidator };
